<template>
  <a-spin :spinning="isAligning">
    <a-input
      :placeholder="$t('shared.searchInputPlaceHolder')"
      @input="e => search(e.target.value)"
    >
      <template #prefix>
        <UserOutlined type="user" />
      </template>
    </a-input>
    <div class="alignment-contact-list">
      <div
        v-if="isLoading"
        :style="{ textAlign: 'center' }"
      >
        <a-spin
          size="small"
        />
      </div>
      <template v-else>
        <div
          v-if="isFrequentContactsVisible"
          class="frequent-contacts-title"
        >
          {{ $t('shared.frequentContacts') }}
        </div>
        <a-space direction="vertical">
          <UserOkr
            v-for="user in users"
            :key="user.uid"
            v-model:is-aligning="isAligning"
            :entity="entity"
            :user="user"
            :is-aligning="isAligning"
            v-bind="$attrs"
          />
        </a-space>
      </template>
    </div>
  </a-spin>
</template>

<script>
import { ref } from 'vue'
import { UserOutlined } from '@ant-design/icons-vue'

import useSearchUser from '@/composables/use-search-user'
import UserOkr from './UserOkr'

export default {
  name: 'AlignOther',
  components: {
    UserOutlined,
    UserOkr
  },
  inheritAttrs: false,
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  setup () {
    const isAligning = ref(false)
    const { users, search, isLoading, isFrequentContactsVisible } = useSearchUser()

    return {
      users,
      search,
      isLoading,
      isAligning,
      isFrequentContactsVisible
    }
  }
}
</script>
